module.exports = __webpack_public_path__ + "static/media/lightbulb-exclamation.78d225b0.svg";